module.exports = __webpack_public_path__ + "img/cars.8c0c8dc6.png";